import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
const Footer = () => {
  return (
    <div className="footermain">
      <div className="footetsub1">
        <div className="footersubclass2mobile">
          <div className="foot2">
            <img
              className="foot2img"
              src="/images/mpeoples.png"
              alt=""
              height="86px"
              width="263px"
            />
          </div>
          <div className="foot3">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/profile.php?id=61561349522345"
              aria-label="Visit our Facebook page"
            >
              <img
                className="foot3img"
                src="/images/fbk.webp"
                alt="fb"
                loading="lazy"
              />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/mpeoples-business-solutions-pvt-ltd/posts/?feedView=all"
              aria-label="Visit our Linkedin page"
            >
              <img
                className="foot3img"
                src="/images/ln.webp"
                alt="linkedin"
                loading="lazy"
              />
            </a>

            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/mpeoples_official/"
              aria-label="Visit our instagram page"
            >
              <img
                className="foot3img"
                src="/images/ig.webp"
                alt="instagram"
                loading="lazy"
              />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.youtube.com/@mpeoplesofficial"
              aria-label="Visit our youtube page"
            >
              <img
                className="foot3img"
                src="/images/yt.webp"
                alt="youtube"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div className="footersubclass1">
          <div className="foot1">
            <p className="foot1h3 fsh3 mt2">Head Office</p>
            <div className="fooimgcon">
              <img
                className="fooimg"
                src="/images/location.webp"
                alt="location"
                loading="lazy"
              />
              <span className="fooimgspan">Head Office Address</span>
            </div>
          </div>
          <div className="address">
            41-A1, 1st floor, Ramaniyagam Complex,
            <br /> Seva Street, Jayamkondacholapuram, <br /> Udayarpalayam,
            Ariyalur- 621802.
          </div>
        </div>
        <div className="footersubclass2">
          <div className="foot2">
            <img
              className="foot2img"
              src="/images/mpeoples.png"
              alt=""
              height="86px"
              width="263px"
              loading="lazy"
            />
          </div>
          <div className="foot3">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/profile.php?id=61561349522345"
              aria-label="Visit our Facebook page (opens in a new tab)"
            >
              <img
                class="foot3img"
                alt="Facebook icon"
                loading="lazy"
                src="/images/fbk.webp"
              />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/mpeoples-business-solutions-pvt-ltd/posts/?feedView=all"
              aria-label="Visit our Linkedin page (opens in a new tab)"
            >
              <img
                className="foot3img"
                src="/images/ln.webp"
                alt="Linkedin icon"
                loading="lazy"
              />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/mpeoples_official/"
              aria-label="Visit our Instagram page (opens in a new tab)"
            >
              <img
                className="foot3img"
                src="/images/ig.webp"
                alt="Instagram icon"
                loading="lazy"
              />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.youtube.com/@mpeoplesofficial"
            >
              <img
                className="foot3img"
                src="/images/yt.webp"
                alt="youtube"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div className="footersubclass1">
          <div className="foot1">
            <p className="foot1h3 fsh3 mt2">Branch Office</p>
            <div className="fooimgcon">
              <img className="fooimg" src="/images/location.webp" alt="" />
              <span className="fooimgspan">Branch Office Address</span>
            </div>
          </div>
          <div className="address">
            MPeoples Business Solutions Pvt Ltd,
            <br /> No 56/3-1 Ranga Nagar, 3rd Cross Street, <br />
            Suramangalam, Salem-636005.
          </div>
        </div>
      </div>
      <div className="footetsub2">
        <div className="footersubclass3">
          <p className="footersubclass3h3 fsh3 mt2">Contact Us</p>
          <div className="footersubclass3div te">
            <img
              className="footersubclass3img"
              src="/images/phone.webp"
              alt=""
              height="30px"
              width="30px"
            />
            <span>
              <a href="https://wa.me/+918508508590">8508508590</a>
            </span>
          </div>
          <div className="d-flex flex-md-row flex-column gap-2">
            <div className="footersubclass3div te">
              <img
                className="footersubclass3img"
                src="/images/mail.webp"
                alt=""
              />
              <span className="d-flex gap-2">
                <strong className="d-md-block d-none">HR:</strong>
                <a href="mailto:hr@mpeoples.in">hr@mpeoples.in</a>
              </span>
            </div>
            <div className="footersubclass3div te">
              <img
                className="footersubclass3img"
                src="/images/mail.webp"
                alt=""
              />
              <span className="d-flex gap-2">
                <strong className="d-md-block d-none">Support:</strong>
                <a href="mailto:support@mpeoples.in">support@mpeoples.in</a>
              </span>
            </div>
          </div>
        </div>
        <div className="footetsub2div">Services</div>
        <div className="footetsub2div1">
          <div className="t">
            <Link to="/uiuxdesign">UI UX Design &#8599;</Link>{" "}
          </div>
          <div className="t">
            <Link to="/web-development"> Web Development &#8599;</Link>
          </div>
          <div className="t">
            <Link to="/mobile-application-development">
              {" "}
              App Development &#8599;
            </Link>
          </div>
          <div className="t">
            <Link to="/digital-marketing"> Digital Marketing &#8599; </Link>
          </div>
          <div className="t">
            <Link to="/customsoftwaresolution">
              {" "}
              Custom Software Solutions &#8599;{" "}
            </Link>
          </div>
        </div>
        <div className="footetsub2div1">
          <div className="t">
            <Link to="/seoservices">SEO Services &#8599;</Link>{" "}
          </div>
          <div className="t">
            <Link to="/social-media-marketing">
              {" "}
              Social Media Marketing &#8599;
            </Link>
          </div>
          <div className="t">
            <Link to="/e-commerce"> E-commerce Development &#8599;</Link>
          </div>
          <div className="t">
            <Link to="/wordpress"> Wordpress Development &#8599; </Link>
          </div>
        </div>
        <div className="footetsub2div hide">Quick Links</div>
        <div className="footetsub2div1 hide">
          <div className="t">
            <Link to="/aboutus/"> About &#8599; </Link>
          </div>
          <div className="t">
            <Link to="/portfolio"> Portfolio &#8599; </Link>
          </div>
          <div className="t">
            <Link to="/contact"> Contact us &#8599; </Link>{" "}
          </div>
          <div className="t">
            <Link to="/privacypolicy/">Privacy Policy &#8599;</Link>{" "}
          </div>
          <div className="t">
            <Link to="/termsandconditions/">Terms & Conditions &#8599;</Link>{" "}
          </div>
          <div className="t">
            <Link to="/paymentpolicy/">Payment Policy &#8599;</Link>
          </div>
        </div>
      </div>
      <hr className="foothr" />
      <div className="footcr">
        <div>Copyright © 2025 mpeoples.in All rights reserved.</div>
      </div>
    </div>
  );
};
export default Footer;
